import.meta.glob(["../images/**", "../fonts/**"]);

// Import AlpineJS
import Alpine from "alpinejs";

// Import AlpineJS Plugins
import ui from "@alpinejs/ui";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import resize from "@alpinejs/resize";

// Import Components
import { animatedGradient } from "./components/animatedGradient";
import { casesFilter } from "./components/casesFilter";
import { contentModal } from "./components/contentModal";
import { contentSlider } from "./components/contentSlider";
import { partnerSlider } from "./components/partnerSlider";
import { primaryNavigation } from "./components/primaryNavigation";

import positionReadMoreButton from "./blocks/media-text";
import switchVideoSource from "./components/videoSelector";
import "./blocks/list-card";

// Make alpine easier to use from the DevTools
window.Alpine = Alpine;

// AlpineJS Components: Headless UI
// https://alpinejs.dev/components
Alpine.plugin(ui);

// AlpineJS PLugin: Collapse for smooth animations
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(resize);

// Register custom AlpineJS Components
Alpine.data("animatedGradient", animatedGradient);
Alpine.data("casesFilter", casesFilter);
Alpine.data("contentModal", contentModal);
Alpine.data("contentSlider", contentSlider);
Alpine.data("partnerSlider", partnerSlider);
Alpine.data("primaryNavigation", primaryNavigation);

Alpine.start();
positionReadMoreButton();
switchVideoSource();
